import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Typography from '@ntuctech/devex-tangram/Typography';
import Box from '@ntuctech/devex-tangram/Box';

const StyledBox = styled(Box)`
  & p {
    text-align: center;
    width: 100%;
  }
`;

const FormDesc = ({ children, spacing, ...rest }) => (
  <StyledBox {...spacing} className="SSOPage__form-desc" {...rest}>
    <Typography variant="body3">{children}</Typography>
  </StyledBox>
);

FormDesc.defaultProps = {
  spacing: { mb: 2 },
};

FormDesc.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  spacing: PropTypes.object,
};

export default FormDesc;
